import { useAuth } from "../context/AuthContext";
import type { ChatSession } from "../types";

interface SidebarProps {
  sessions: ChatSession[];
  activeSessionId: string | null;
  radiusKm: number;
  onSelectSession: (id: string) => void;
  onDeleteSession: (id: string) => void;
  onNewChat: () => void;
  onRadiusChange: (radius: number) => void;
}

export function Sidebar({
  sessions,
  activeSessionId,
  radiusKm,
  onSelectSession,
  onDeleteSession,
  onNewChat,
  onRadiusChange,
}: SidebarProps) {
  const { user, logout } = useAuth();

  // newest first, like the Streamlit sidebar
  const orderedSessions = [...sessions].reverse();

  return (
    <aside className="sidebar">
      {user && (
        <div className="user-badge">
          <span className="user-badge-caption">
            Logged in as <strong>{user.display_name}</strong>
          </span>
          <button className="btn btn-secondary btn-block" onClick={logout}>
            Log out
          </button>
        </div>
      )}

      <hr />

      <h3 className="sidebar-heading">⚡ EV Sales Count</h3>

      <button className="btn btn-primary btn-block" onClick={onNewChat}>
        + New Chat
      </button>

      <div className="radius-control">
        <label htmlFor="radius-slider">Search radius (km)</label>
        <input
          id="radius-slider"
          type="range"
          min={5}
          max={100}
          step={5}
          value={radiusKm}
          onChange={(e) => onRadiusChange(Number(e.target.value))}
        />
        <span className="radius-value">{radiusKm} km</span>
      </div>

      <hr />

      {sessions.length === 0 ? (
        <p className="muted-caption">No chats yet</p>
      ) : (
        <ul className="session-list">
          {orderedSessions.map((session) => (
            <li key={session.id} className={session.id === activeSessionId ? "session-item active" : "session-item"}>
              <button className="session-select" onClick={() => onSelectSession(session.id)}>
                {session.title || "New chat"}
              </button>
              <button
                className="session-delete"
                aria-label="Delete chat"
                title="Delete chat"
                onClick={() => onDeleteSession(session.id)}
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
